export const actionTypes = {
  REQUEST_START: 'PROFILE.CERTIFICATE_INFO.REQUEST_START',
  REQUEST_SUCCESS: 'PROFILE.CERTIFICATE_INFO.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.CERTIFICATE_INFO.REQUEST_FAILURE',
};

export function startRequest(data) {
  return {
    type: actionTypes.REQUEST_START,
    payload: data,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
